import Logger from '@/lib/logger';
import { NEXT_PUBLIC_GTM_LOGGING_ENABLED } from '@/lib/env';

const logger = new Logger('GTM', 'DEBUG');

if (NEXT_PUBLIC_GTM_LOGGING_ENABLED) {
  logger.enable();
}

export default logger;
